import {
    GET_LIST_REQUEST,
    GET_LIST_SUCCESS,
    GET_LIST_ERROR,
} from '../../actions'

export const initialItemState = {
    loading: false,
    params: {
        page: 0,
        limit: 50,
        order: '',
        query: null,
        total: 0
    },
    items: [],
}

const initialState = {}

var currentState = null;

const lists = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_REQUEST:
            currentState = state[action.payload.key] || initialItemState;
            return {
                ...state,
                [action.payload.key]: {
                    ...currentState,
                    loading: true,
                    params: {
                        ...currentState.params,
                        ...action.payload.params
                    }
                }
            }
        case GET_LIST_SUCCESS:
            currentState = state[action.payload.original.key] || initialItemState;
            return {
                ...state,
                [action.payload.original.key]: {
                    ...currentState,
                    loading: false,
                    items: action.payload.items,
                    params: {
                        ...currentState.params,
                        total: action.payload.total
                    }
                }
            }
            
        case GET_LIST_ERROR:
            currentState = state[action.payload.original.key] || initialItemState;
            return {
                ...state,
                [action.payload.original.key]: {
                    ...currentState,
                    loading: false,
                }
            }
        default:
            return state
    }
}

export default lists



// WEBPACK FOOTER //
// ./src/reducers/data/lists.js